'use client';
const getListWrapperAttributes = (id)=>{
    return {
        'data-combobox-popover': true,
        'aria-labelledby': `${id}-label`,
        id: `${id}-items`,
        role: 'listbox',
        tabIndex: -1
    };
};

export { getListWrapperAttributes };
//# sourceMappingURL=getListWrapperAttributes.js.map
